export default __webpack_public_path__ + "1d11cbd4e33938b1152fa7a444b1b47d.png";